module.exports = __webpack_public_path__ + "static/media/envelope-open.adae93c9.svg";